import jwt_decode from 'jwt-decode';

// Returns the userType claim from a valid access token, or undefined when missing or expired.
export function getAccessTokenUserType(): string | undefined {
  const token = localStorage.getItem('accessToken');

  if (!token) {
    return undefined;
  }

  try {
    const decoded: { userType?: string; exp?: number } = jwt_decode(token);

    if (decoded.userType && decoded.exp && decoded.exp * 1000 > Date.now()) {
      return decoded.userType;
    }
  } catch {
    return undefined;
  }

  return undefined;
}

// Returns the post-login route for an authenticated user based on userType.
export function getAuthenticatedHomeRoute(): string {
  const userType = getAccessTokenUserType();

  if (userType === 'patient') {
    return '/calibration';
  }

  if (userType === 'doctor') {
    return '/doctor_home';
  }

  return '/';
}
